import { useState, useContext, useEffect } from "react"
import { ContentContext } from "../contexts/ContentContext"
import { ticketStatusConfigs } from "./TicketComponents"
import { AccountContext } from "../contexts/AccountContexts"
import { IoSearch } from "react-icons/io5"
import { MdRestartAlt } from "react-icons/md"
import { AiOutlineClear } from "react-icons/ai"
import { requestAdvancedSearchTickets, requestPaginationSearchTickets } from "../requests/ticket_requests"
import { loadingActive, pageLoadingActive } from "./Background"
import { useTranslation } from "react-i18next"
import { darkAndLightThemeDefault } from "./ThemeComponents"




export const TicketSearchComponent = ({ getData, currentPage, setCurrentPage, entriesPerPage, setEntriesPerPage, isDefault, setIsDefault, sortConfig, 
    setSortConfig, setTotalPages, setTotalCount, filterTaggedChats, setFilterTaggedChats }) => {
    const { t } = useTranslation(['edit', 'common'])
    const { user, devs, language } = useContext(AccountContext)
    const { categories, priorities, servers, openErrorModal } = useContext(ContentContext)

    const [ticketId, setTicketId] = useState("")
    const [ticketIdMode, setTicketIdMode] = useState(1)
    const [name, setName] = useState("")
    const [nameMode, setNameMode] = useState(1)
    const [email, setEmail] = useState("")
    const [emailMode, setEmailMode] = useState(1)
    const [characterName, setCharacterName] = useState("")
    const [characterNameMode, setCharacterNameMode] = useState(1)
    const [selectedServer, setSelectedServer] = useState("All")
    const [selectedCategory, setSelectedCategory] = useState("All")
    const [selectedStatus, setSelectedStatus] = useState("All")
    const [selectedPriority, setSelectedPriority] = useState("All")
    const [selectedDeveloper, setSelectedDeveloper] = useState(user ? user.id : "All")

    const [firstSearch, setFirstSearch] = useState(false)
    const [isAdvanced, setIsAdvanced] = useState(false)
    const [doSearch, setDoSearch] = useState(false)

    const [isHighlight, setIsHighlight] = useState(false)

    const getPrevSearchParams = () => {
        const searchParams = localStorage.getItem(user.id + "_prevSearchParams1")
        return searchParams
    }

    useEffect(() => {
        if (isHighlight) {
            setIsHighlight(false)
        }
    }, [ticketId, ticketIdMode, name, nameMode, email, emailMode, characterName, characterNameMode, selectedServer, selectedCategory, selectedStatus, selectedPriority, selectedDeveloper])

    const saveSearchParams = (default_) => {
        const searchParams = {
            isDefault: default_,
            ticketId: default_ ? "" : ticketId,
            ticketIdMode: default_ ? 1 : ticketIdMode,
            name: default_ ? "" : name,
            nameMode: default_ ? 1 : nameMode,
            email: default_ ? "" : email,
            emailMode: default_ ? 1 : emailMode,
            characterName: default_ ? "" : characterName,
            characterNameMode: default_ ? 1 : characterNameMode,
            selectedServer: default_ ? "All" : selectedServer,
            selectedCategory: default_ ? "All" : selectedCategory,
            selectedStatus: default_ ? "All" : selectedStatus,
            selectedPriority: default_ ? "All" : selectedPriority,
            selectedDeveloper: default_ ? user.id : selectedDeveloper,
            currentPage: currentPage,
            entriesPerPage: entriesPerPage,
            sortByIndex: sortConfig.key,
            order: sortConfig.direction
        }
        localStorage.setItem(user.id + "_prevSearchParams1", JSON.stringify(searchParams))
    }

    const removeSearchParams = () => {
        localStorage.removeItem(user.id + "_prevSearchParams1")
    }

    useEffect(() => {
        let searchParams = getPrevSearchParams()
        if (searchParams) {
            searchParams = JSON.parse(searchParams)
            setIsDefault(searchParams.isDefault)
            setTicketId(searchParams.ticketId)
            setTicketIdMode(parseInt(searchParams.ticketIdMode))
            setName(searchParams.name)
            setNameMode(parseInt(searchParams.nameMode))
            setEmail(searchParams.email)
            setEmailMode(parseInt(searchParams.emailMode))
            setCharacterName(searchParams.characterName)
            setCharacterNameMode(parseInt(searchParams.characterNameMode))
            setSelectedServer(searchParams.selectedServer)
            setSelectedCategory(searchParams.selectedCategory)
            setSelectedStatus(searchParams.selectedStatus)
            setSelectedPriority(searchParams.selectedPriority)
            setSelectedDeveloper(searchParams.selectedDeveloper)
            setCurrentPage(parseInt(searchParams.currentPage))
            setEntriesPerPage(parseInt(searchParams.entriesPerPage))
            setSortConfig({ key: searchParams.sortByIndex, direction: searchParams.order })

            setFirstSearch(true)
        }
        else {
            handleDefault()
        }

    }, [])

    useEffect(() => {
        if (doSearch && !isAdvanced) {
            handleSearch(isDefault)
        }
    }, [doSearch])


    useEffect(() => {
        if (firstSearch) {
            setDoSearch(true)
            setFirstSearch(false)
        }
    }, [firstSearch])

    useEffect(() => {
        if (!firstSearch) {
            setDoSearch(true)
        }
    }, [entriesPerPage, sortConfig.key, sortConfig.direction])

    useEffect(() => {
        if (!firstSearch) {
            if (!doSearch) {
                setDoSearch(true)
            }
        }
    }, [currentPage])

    const handleSearch = (default_ = false) => {
        if(filterTaggedChats){
            default_ = false
        }
        pageLoadingActive(true)
        if(filterTaggedChats){
            setSelectedDeveloper("All")
        }
        requestPaginationSearchTickets({
            isDefault: default_,
            ticketId: ticketId,
            ticketIdMode: ticketIdMode,
            name: name,
            nameMode: nameMode,
            email: email,
            emailMode: emailMode,
            characterName: characterName,
            characterNameMode: characterNameMode,
            selectedServer: selectedServer,
            selectedCategory: selectedCategory,
            selectedStatus: selectedStatus,
            selectedPriority: selectedPriority,
            selectedDeveloper: selectedDeveloper,
            currentPage: currentPage,
            entriesPerPage: entriesPerPage,
            sortByIndex: sortConfig.key,
            order: sortConfig.direction,
            tagged: filterTaggedChats
        })
            .then((data) => {
                getData(data.tickets, data.users)
                setTotalPages(data.total_pages)
                setTotalCount(data.total_count)
                saveSearchParams(default_)
                setIsAdvanced(false)
                setIsHighlight(true)
            })
            .catch((error) => {
                openErrorModal(error)
                console.error(error.status, error.message)
            })
            .finally(() => {
                setDoSearch(false)
                pageLoadingActive(false)
            })
    }

    const handleRegularSearch = () => {
        setCurrentPage(1)
        setSortConfig({ key: null, direction: "desc" })
        setIsDefault(false)
        setIsAdvanced(false)
        handleSearch(false)
    }


    const handleDefault = () => {
        setCurrentPage(1)
        setSortConfig({ key: null, direction: "desc" })
        handleClear()
        setIsDefault(true)
        setIsAdvanced(false)
        handleSearch(true)
    }

    const handleClear = () => {
        setTicketId("")
        setTicketIdMode(1)
        setName("")
        setNameMode(1)
        setEmail("")
        setEmailMode(1)
        setCharacterName("")
        setCharacterNameMode(1)
        setSelectedServer("All")
        setSelectedCategory("All")
        setSelectedStatus("All")
        setSelectedPriority("All")
        setSelectedDeveloper(user ? user.id : "All")
        // setCurrentPage(1)
        // setSortConfig({key: null, direction: "desc"})

        removeSearchParams()
    }

    const handleOpenAdvancedSearch = () => {
        document.getElementById("tickets-advanced-search-modal").showModal()
    }

    return (
        <div className="flex justify-center gap-4 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 w-full rounded-lg p-5 ">
            <AdvancedSearchModal isAdvanced={isAdvanced} setIsAdvanced={setIsAdvanced} doSearch={doSearch} setDoSearch={setDoSearch} currentPage={currentPage} setCurrentPage={setCurrentPage} entriesPerPage={entriesPerPage} sortConfig={sortConfig} getData={getData} setTotalPages={setTotalPages} setTotalCount={setTotalCount} />
            <div className="flex flex-col gap-1">
                <h1>{t('Ticket ID')}</h1>
                <input type="input" value={ticketId} onChange={(e) => { setTicketId(e.target.value) }} placeholder={t("Type Ticket ID")} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${ticketId !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                <select required value={ticketIdMode || 1} onChange={(e) => setTicketIdMode(e.target.value)} className="select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" >
                    <option value={1}>{t('Contains')}</option>
                    <option value={2}>{t('Exact')}</option>
                </select>
            </div>

            <div className="flex flex-col gap-1">
                <h1>{t('Name')}</h1>
                <input type="input" value={name} onChange={(e) => { setName(e.target.value) }} placeholder={t("Type name")} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${name !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                <select required value={nameMode || 1} onChange={(e) => setNameMode(e.target.value)} className="select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" >
                    <option value={1}>{t('Contains')}</option>
                    <option value={2}>{t('Exact')}</option>
                </select>
            </div>

            <div className="flex flex-col gap-1">
                <h1>{t('E-mail')}</h1>
                <input type="input" value={email} onChange={(e) => { setEmail(e.target.value) }} placeholder={t('Type E-mail')} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${email !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                <select required value={emailMode || 1} onChange={(e) => setEmailMode(e.target.value)} className="select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" >
                    <option value={1}>{t('Contains')}</option>
                    <option value={2}>{t('Exact')}</option>
                </select>
            </div>

            <div className="flex flex-col gap-1">
                <h1>{t('Character Name')}</h1>
                <input type="input" value={characterName} onChange={(e) => { setCharacterName(e.target.value) }} placeholder={t('Type Character Name')} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${characterName !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                <select required value={characterNameMode || 1} onChange={(e) => setCharacterNameMode(e.target.value)} className="select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" >
                    <option value={1}>{t('Contains')}</option>
                    <option value={2}>{t('Exact')}</option>
                </select>
            </div>

            <div className="flex flex-col gap-1">
                <h1>{t('Server')}</h1>
                <select required value={selectedServer || "All"} onChange={(e) => setSelectedServer(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedServer !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`}>
                    <option value={"All"}>{t('All')}</option>
                    {Object.values(servers).map((el, index) => (<option key={index} value={el.id}>{el.title}</option>))}
                </select>
            </div>

            <div className="flex flex-col gap-1">
                <h1>{t('Category')}</h1>
                <select required value={selectedCategory || "All"} onChange={(e) => setSelectedCategory(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedCategory !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                    <option value={"All"}>{t('All')}</option>
                    {Object.values(categories).map((el, index) => (<option key={index} value={el.id}>{el?.locales?.[language] ? el?.locales?.[language] : t(el.title, { 'ns': 'common' })}</option>))}
                </select>
            </div>

            <div className="flex flex-col gap-1">
                <h1>{t('Status')}</h1>
                <select required value={selectedStatus || "All"} onChange={(e) => setSelectedStatus(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedStatus !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                    <option value={"All"}>{t('All')}</option>
                    {Object.values(ticketStatusConfigs).map((el, index) => (<option key={index} value={el.status}>{t(el.status, { 'ns': 'common' })}</option>))}
                </select>
            </div>

            <div className="flex flex-col gap-1">
                <h1>{t('Priority')}</h1>
                <select required value={selectedPriority || "All"} onChange={(e) => setSelectedPriority(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedPriority !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                    <option value={"All"}>{t('All')}</option>
                    {Object.values(priorities).map((el, index) => (<option key={index} value={el.id}>{t(el.title, { 'ns': 'common' })}</option>))}
                </select>
            </div>

            <div className="flex flex-col gap-1">
                <h1>{t('Employee')}</h1>
                <select required value={selectedDeveloper || "All"} onChange={(e) => setSelectedDeveloper(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedDeveloper !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                    <option value={"All"}>{t('All')}</option>
                    {Object.values(devs).map((dev, index) => (<option key={index} value={dev.id}>{dev.name}</option>))}
                </select>
            </div>

            <div className="flex flex-col gap-2 my-auto">
                <div className="flex gap-1">
                    <button className={`btn btn-sm btn-square ${isHighlight && !isDefault && !isAdvanced ? "border-2 border-green-500 dark:border-sky-400" : "border-none"} bg-primary dark:bg-blue-600 dark:hover:bg-primary text-white hover:bg-primary/80`}  title={t("Search")} onClick={handleRegularSearch}><IoSearch /></button>
                    <button className={`btn btn-sm btn-square  ${isHighlight && isDefault && !isAdvanced ? "border-2 border-green-500 dark:border-sky-400" : "border-none"} bg-primary dark:bg-blue-600 dark:hover:bg-primary text-white hover:bg-primary/80 `} title={t("Default")} onClick={handleDefault}><MdRestartAlt size={18} /></button>
                    <button className="btn btn-sm btn-square border-none bg-white text-primary hover:bg-gray-200 border border-primary" title={t("Clear")} onClick={handleClear}><AiOutlineClear size={16} /></button>
                </div>
                <div>
                    <button className={`btn btn-sm ${darkAndLightThemeDefault} ${isHighlight && isAdvanced ? "border-green-500 dark:border-sky-400" : ""}`} onClick={handleOpenAdvancedSearch}>{t('Advanced Search')}</button>
                </div>
            </div>

        </div>
    )
}


const AdvancedSearchModal = ({ currentPage, entriesPerPage, sortConfig, getData, setTotalCount, setTotalPages, isAdvanced, setIsAdvanced, doSearch, setCurrentPage, setDoSearch }) => {
    const { t } = useTranslation(['edit', 'common'])
    const { user, devs, language } = useContext(AccountContext)
    const { categories, priorities, servers, openErrorModal } = useContext(ContentContext)

    const [ticketId, setTicketId] = useState("")
    const [ticketIdMode, setTicketIdMode] = useState(1)
    const [name, setName] = useState("")
    const [nameMode, setNameMode] = useState(1)
    const [email, setEmail] = useState("")
    const [emailMode, setEmailMode] = useState(1)
    const [characterName, setCharacterName] = useState("")
    const [characterNameMode, setCharacterNameMode] = useState(1)
    const [selectedServer, setSelectedServer] = useState("All")
    const [selectedCategory, setSelectedCategory] = useState("All")
    const [selectedStatus, setSelectedStatus] = useState("All")
    const [selectedPriority, setSelectedPriority] = useState("All")
    const [selectedDeveloper, setSelectedDeveloper] = useState("All")

    const [subject, setSubject] = useState("")
    const [description, setDescription] = useState("")
    const [chatMessage, setChatMessage] = useState("")

    const [createdAt, setCreatedAt] = useState(-1)
    const [lastUpdated, setLastUpdated] = useState(-1)

    const [searchInProgress, setSearchInProgress] = useState(false)

    useEffect(() => {
        if (doSearch && isAdvanced) {
            onSearch()
        }
    }, [doSearch])

    const saveSearchParams = () => {
        const searchParams = {
            ticketId: ticketId,
            ticketIdMode: ticketIdMode,
            name: name,
            nameMode: nameMode,
            email: email,
            emailMode: emailMode,
            characterName: characterName,
            characterNameMode: characterNameMode,
            selectedServer: selectedServer,
            selectedCategory: selectedCategory,
            selectedStatus: selectedStatus,
            selectedPriority: selectedPriority,
            selectedDeveloper: selectedDeveloper,
            subject: subject,
            description: description,
            chatMessage: chatMessage,
            createdAt: createdAt,
            lastUpdated: lastUpdated,
            currentPage: currentPage,
            entriesPerPage: entriesPerPage,
            sortByIndex: sortConfig.key,
            order: sortConfig.direction
        }
        // localStorage.setItem(user.id + "_prevAdvancedSearchParams", JSON.stringify(searchParams))
    }

    const removeSearchParams = () => {
        localStorage.removeItem(user.id + "_prevAdvancedSearchParams")
    }

    const onSearch = () => {
        loadingActive(true)
        setSearchInProgress(true)
        requestAdvancedSearchTickets({
            ticketId: ticketId,
            ticketIdMode: ticketIdMode,
            name: name,
            nameMode: nameMode,
            email: email,
            emailMode: emailMode,
            characterName: characterName,
            characterNameMode: characterNameMode,
            selectedServer: selectedServer,
            selectedCategory: selectedCategory,
            selectedStatus: selectedStatus,
            selectedPriority: selectedPriority,
            selectedDeveloper: selectedDeveloper,
            subject: subject,
            description: description,
            chatMessage: chatMessage,
            createdAt: createdAt,
            lastUpdated: lastUpdated,
            currentPage: currentPage,
            entriesPerPage: entriesPerPage,
            sortByIndex: sortConfig.key,
            order: sortConfig.direction,
            tagged: false
        })
            .then((data) => {
                getData(data.tickets, data.users)
                setTotalPages(data.total_pages)
                setTotalCount(data.total_count)
                setIsAdvanced(true)
                saveSearchParams()
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
            .finally(() => {
                loadingActive(false)
                setDoSearch(false)
                setSearchInProgress(false)
                onClose()
            })
    }


    const onClose = () => {
        document.getElementById("tickets-advanced-search-modal").close()
    }

    const onClear = () => {
        setTicketId("")
        setTicketIdMode(1)
        setName("")
        setNameMode(1)
        setEmail("")
        setEmailMode(1)
        setCharacterName("")
        setCharacterNameMode(1)
        setSelectedServer("All")
        setSelectedCategory("All")
        setSelectedStatus("All")
        setSelectedPriority("All")
        setSelectedDeveloper("All")
        setSubject("")
        setDescription("")
        setChatMessage("")
        setCreatedAt(-1)
        setLastUpdated(-1)
    }


    const handleSearch = () => {
        setCurrentPage(1)
        setIsAdvanced(true)
        setDoSearch(true)
    }

    return (
        <>
            <dialog id="tickets-advanced-search-modal" className="modal" >
                <div className="modal-box flex flex-col gap-3 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 overflow-auto max-h-[700px] w-2/3 max-w-full">
                    <span className="text-center text-lg">{t('Advanced Search')}</span>
                    <div className="grid grid-cols-4 gap-3">

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Ticket ID')}</h1>
                            <input type="input" value={ticketId} onChange={(e) => { setTicketId(e.target.value) }} placeholder={t("Type Ticket ID")} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${ticketId !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                            <select required value={ticketIdMode || 1} onChange={(e) => setTicketIdMode(e.target.value)} className="select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" >
                                <option value={1}>{t('Contains')}</option>
                                <option value={2}>{t('Exact')}</option>
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Name')}</h1>
                            <input type="input" value={name} onChange={(e) => { setName(e.target.value) }} placeholder={t("Type name")} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${name !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                            <select required value={nameMode || 1} onChange={(e) => setNameMode(e.target.value)} className="select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" >
                                <option value={1}>{t('Contains')}</option>
                                <option value={2}>{t('Exact')}</option>
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('E-mail')}</h1>
                            <input type="input" value={email} onChange={(e) => { setEmail(e.target.value) }} placeholder={t('Type E-mail')} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${email !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                            <select required value={emailMode || 1} onChange={(e) => setEmailMode(e.target.value)} className="select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" >
                                <option value={1}>{t('Contains')}</option>
                                <option value={2}>{t('Exact')}</option>
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Character Name')}</h1>
                            <input type="input" value={characterName} onChange={(e) => { setCharacterName(e.target.value) }} placeholder={t('Type Character Name')} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${characterName !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                            <select required value={characterNameMode || 1} onChange={(e) => setCharacterNameMode(e.target.value)} className="select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" >
                                <option value={1}>{t('Contains')}</option>
                                <option value={2}>{t('Exact')}</option>
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Server')}</h1>
                            <select required value={selectedServer || "All"} onChange={(e) => setSelectedServer(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedServer !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                                <option value={"All"}>{t('All')}</option>
                                {Object.values(servers).map((el, index) => (<option key={index} value={el.id}>{el.title}</option>))}
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Category')}</h1>
                            <select required value={selectedCategory || "All"} onChange={(e) => setSelectedCategory(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedCategory !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                                <option value={"All"}>{t('All')}</option>
                                {Object.values(categories).map((el, index) => (<option key={index} value={el.id}>{el?.locales?.[language] ? el?.locales?.[language] : t(el.title, { 'ns': 'common' })}</option>))}
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Status')}</h1>
                            <select required value={selectedStatus || "All"} onChange={(e) => setSelectedStatus(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedStatus !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                                <option value={"All"}>{t('All')}</option>
                                {Object.values(ticketStatusConfigs).map((el, index) => (<option key={index} value={el.status}>{t(el.status, { 'ns': 'common' })}</option>))}
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Priority')}</h1>
                            <select required value={selectedPriority || "All"} onChange={(e) => setSelectedPriority(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedPriority !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                                <option value={"All"}>{t('All')}</option>
                                {Object.values(priorities).map((el, index) => (<option key={index} value={el.id}>{t(el.title, { 'ns': 'common' })}</option>))}
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Employee')}</h1>
                            <select required value={selectedDeveloper || "All"} onChange={(e) => setSelectedDeveloper(e.target.value)} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${selectedDeveloper !== "All" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                                <option value={"All"}>{t('All')}</option>
                                {Object.values(devs).map((dev, index) => (<option key={index} value={dev.id}>{dev.name}</option>))}
                            </select>
                        </div>
                    </div>

                    <div className="flex gap-3 w-full">

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Subject')}</h1>
                            <input type="input" value={subject} onChange={(e) => { setSubject(e.target.value) }} placeholder={t("Search in subject")} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${subject !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Description')}</h1>
                            <input type="input" value={description} onChange={(e) => { setDescription(e.target.value) }} placeholder={t("Search in description")} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${description !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                        </div>
                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Chat messages')}</h1>
                            <input type="input" value={chatMessage} onChange={(e) => { setChatMessage(e.target.value) }} placeholder={t("Search in chats")} className={`input input-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-[1px] ${chatMessage !== "" ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} />
                        </div>
                    </div>

                    <div className="flex gap-3 w-full">

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Created At')}</h1>
                            <select required value={createdAt || -1} onChange={(e) => setCreatedAt(parseInt(e.target.value))} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${parseInt(createdAt) !== -1 ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                            <option value={-1}>{t("timePassed.anytime")}</option>
                                <option value={24 * 3600}>{t('timePassed.last_day')}</option>
                                <option value={7 * 24 * 3600}>{t('timePassed.last_week')}</option>
                                <option value={30 * 24 * 3600}>{t('timePassed.last_month')}</option>
                                <option value={90 * 24 * 3600}>{t('timePassed.last_3_months')}</option>
                                <option value={180 * 24 * 3600}>{t('timePassed.last_6_months')}</option>
                                <option value={365 * 24 * 3600}>{t('timePassed.last_year')}</option>
                            </select>
                        </div>

                        <div className="flex flex-col gap-1 max-w-[290px] w-full">
                            <h1>{t('Last Update')}</h1>
                            <select required value={lastUpdated || -1} onChange={(e) => setLastUpdated(parseInt(e.target.value))} className={`select select-sm select-bordered select-md w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 ${parseInt(lastUpdated) !== -1 ? "border-blue-400" : "border-gray-300 dark:border-gray-500"}`} >
                                <option value={-1}>{t("timePassed.anytime")}</option>
                                <option value={24 * 3600}>{t('timePassed.last_day')}</option>
                                <option value={7 * 24 * 3600}>{t('timePassed.last_week')}</option>
                                <option value={30 * 24 * 3600}>{t('timePassed.last_month')}</option>
                                <option value={90 * 24 * 3600}>{t('timePassed.last_3_months')}</option>
                                <option value={180 * 24 * 3600}>{t('timePassed.last_6_months')}</option>
                                <option value={365 * 24 * 3600}>{t('timePassed.last_year')}</option>
                            </select>
                        </div>
                    </div>

                    <div className="flex gap-3 w-full justify-center mt-6">
                        <button className="btn bg-primary hover:bg-primary/70 text-white border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500" disabled={searchInProgress} onClick={handleSearch}>{t('Search')}</button>
                        <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClear}>{t('Clear')}</button>
                        <button className={`btn ${darkAndLightThemeDefault}`} onClick={onClose}>{t('Close')}</button>
                    </div>

                </div>
                <form method="dialog" className="modal-backdrop">
                    <button onClick={onClose}>close</button>
                </form>
            </dialog>

        </>
    )
}